import React,{useEffect, useState} from 'react';
import {supabase} from "../components/supabaseClient"
import {useNavigate} from "react-router-dom";

const SignIn: React.FC = ()=>{
  const [email, set_email] = useState("")
  const [password, set_password] = useState("")
  const navigate = useNavigate();

  const handleSignIn = async () => {
    console.log("email:", email, "password:", password)
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    })

    if(data.session === null || data.user === null) {
      alert("Emailアドレスかパスワードが違います")
    }

    console.log(data)

    navigate("/")
    
  }

  return (
    <div>
      <div className="bg-white py-6 sm:py-8 lg:py-12">
        <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
          <h2 className="mb-4 text-center text-2xl font-bold text-gray-800 md:mb-8 lg:text-3xl">Sign In</h2>

          <div className="mx-auto max-w-lg rounded-lg border">
            <div className="flex flex-col gap-4 p-4 md:p-8">
              <div>
                <label className="mb-2 inline-block text-sm text-gray-800 sm:text-base">Email</label>
                <input value={email} onChange={(e)=>set_email(e.target.value)} className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-800 outline-none ring-indigo-300 transition duration-100 focus:ring" />
              </div>

              <div>
                <label  className="mb-2 inline-block text-sm text-gray-800 sm:text-base">Password</label>
                <input value={password} onChange={(e)=>set_password(e.target.value)} className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-800 outline-none ring-indigo-300 transition duration-100 focus:ring" />
              </div>

              <button onClick={handleSignIn} className="block rounded-lg bg-gray-800 px-8 py-3 text-center text-sm font-semibold text-white outline-none ring-gray-300 transition duration-100 hover:bg-gray-700 focus-visible:ring active:bg-gray-600 md:text-base">Sign in</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

export default SignIn